/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

window.addEventListener('load', function () {
    // Function to add a class to an element
    function addClass(element, className) {
        if (!element.classList.contains(className)) {
            element.classList.add(className);
        }
    }
    
    // Function to remove a class from an element
    function removeClass(element, className) {
        if (element.classList.contains(className)) {
            element.classList.remove(className);
        }
    }
    
    // Function to handle tab clicks
    function handleTabClick(event) {
        event.preventDefault();
    
        // Remove 'active' class from all tabs
        var tabs = document.querySelectorAll('.p-tabs__tab');
        tabs.forEach(function (tab) {
            removeClass(tab, 'active');
        });
    
        // Add 'active' class to the clicked tab
        addClass(this, 'active');
    
        // Get the data-tab attribute value
        var id = this.getAttribute('data-tab');
    
        // Remove 'active' class from all content
        var contents = document.querySelectorAll('.p-tabs__content');
        contents.forEach(function (content) {
            removeClass(content, 'active');
        });
    
        // Add 'active' class to the corresponding content
        addClass(document.getElementById(id), 'active');

        var top = document.querySelector('.p-tabs__list').getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({
            top: top,
            behavior: 'instant'
        });
        setTimeout(function () {
            
        }, 50);
    }
    
    // Function to handle mobile tab clicks
    function handleMobileTabClick(event) {
        event.preventDefault();
    
        if (this.classList.contains('active')) {
            this.classList.toggle('active');
            this.nextElementSibling.style.display = 'none';
        } else {
            var activeTab = document.querySelector('.p-tabs__mob-tab.active');
            if (activeTab) {
                activeTab.nextElementSibling.style.display = 'none';
                removeClass(activeTab, 'active');
            }
    
            this.classList.toggle('active');
            this.nextElementSibling.style.display = 'block';
        }
    }
    
    // Attach click event to each tab
    var tabs = document.querySelectorAll('.p-tabs__tab');
    tabs.forEach(function (tab) {
        tab.addEventListener('click', handleTabClick);
    });
    
    // Attach click event to each mobile tab
    var mobileTabs = document.querySelectorAll('.p-tabs__mob-tab');
    mobileTabs.forEach(function (mobileTab) {
        mobileTab.addEventListener('click', handleMobileTabClick);
    });

    setTimeout(function () {
      document.querySelectorAll(".ga-product").forEach((item) => {
        item.addEventListener("click", (e) => {
          let input = item.querySelector("input");
          console.log(input);
          input.click();
        });
      });

    document.querySelectorAll(".ga-product_title").forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  }, 1000);

    // document.querySelectorAll('.ga-product_price-container').forEach(item => {
    //     item.addEventListener('click', function() {
    //         item.closest('.ga-product').querySelector('input').click();
    //     })
    // })

    let player;

    function onYouTubeIframeAPIReady() {
      player = new YT.Player('youtube-player', {
        height: '360',
        width: '640',
        videoId: 'F33fVN4NwUU', // Изначально видео нет
        playerVars: {
          autoplay: 0, // Автозапуск выключен по умолчанию
          controls: 1, // Показывать элементы управления
        },
      });
    }
  
    // Функция для загрузки и воспроизведения видео
    function playVideo(videoId) {
        console.log(player)
      if (player) {
        player.loadVideoById(videoId); // Загружаем видео
      }
    }

    var done = false;

    document.querySelectorAll('[data-video-popup]').forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            let link = item.getAttribute('data-video-popup');
            let videoId = link.split('/')[3];
            let popup = document.querySelector('.video-popup');
            let iframe = document.querySelector('.video-popup__iframe');
            // iframe.src = `${link}?autoplay=1&enablejsapi=1`;
            popup.classList.add('active');
            player = new YT.Player('youtube-player', {
                height: '390',
                width: '640',
                videoId: videoId,
                playerVars: {
                  'playsinline': 1
                },
                events: {
                  'onReady': onPlayerReady,
                  'onStateChange': onPlayerStateChange
                }
              });
        })
    })
    function onPlayerStateChange(event) {
        
    }
    function stopVideo() {
        player.stopVideo();
    }
    function onPlayerReady(event) {
        event.target.playVideo();
      }

      document.addEventListener('click', function(e) {
        console.log(e.target)
        if(e.target.classList.contains('video-popup')) {
            document.querySelector('.video-popup').classList.remove('active');
            player.stopVideo();
            player.destroy();
        }
      })

    document.querySelector('.video-popup__close').addEventListener('click', elem => {
        document.querySelector('.video-popup').classList.remove('active');
        player.stopVideo();
        player.destroy();
    })
})